import { Tooltip, chakra, useColorModeValue, Center } from '@chakra-ui/react';
import React from 'react';

import IconSvg from 'ui/shared/IconSvg';

import type { TxCourseType } from './utils';

interface Props {
  isLoading?: boolean;
  type: TxCourseType;
  className?: string;
}

const CIRCLE_SIZE = '28px';

const AddressFromToIcon = ({ isLoading, type, className }: Props) => {
  const styles = {
    in: {
      bg: useColorModeValue('#E6FAE6', 'green.900'),
      color: useColorModeValue('#1e7e34', 'green.300'),
      borderColor: useColorModeValue('#A6DBA6', 'green.600'),
    },
    out: {
      bg: useColorModeValue('#FFF3E0', 'orange.900'),
      color: useColorModeValue('#E65100', 'orange.300'),
      borderColor: useColorModeValue('#FFB74D', 'orange.600'),
    },
    self: {
      bg: useColorModeValue('#e2e3e5', 'whiteAlpha.200'),
      color: useColorModeValue('#41464b', 'gray.400'),
      borderColor: useColorModeValue('gray.400', 'gray.500'),
    },
    unspecified: {
      bg: useColorModeValue('#E6FAE6', 'green.900'),
      color: useColorModeValue('#1e7e34', 'green.300'),
      borderColor: useColorModeValue('#A6DBA6', 'green.600'),
    },
  };

  const labels = {
    in: 'Incoming txn',
    out: 'Outgoing txn',
    self: 'Txn to the same address',
    unspecified: 'Transfer',
  };

  const s = styles[type];

  const arrowCircle = (
    <Center
      className={ className }
      w={ CIRCLE_SIZE }
      h={ CIRCLE_SIZE }
      minW={ CIRCLE_SIZE }
      minH={ CIRCLE_SIZE }
      borderRadius="full"
      bg={ s.bg }
      border="1px solid"
      borderColor={ s.borderColor }
      flexShrink={ 0 }
    >
      <IconSvg
        name="arrows/east"
        color={ s.color }
        isLoading={ isLoading }
        boxSize={ 4 }
      />
    </Center>
  );

  return (
    <Tooltip label={ labels[type] }>
      { arrowCircle }
    </Tooltip>
  );
};

export default React.memo(chakra(AddressFromToIcon));
